import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

class IFrameEmbedComponent extends Component {
  init() {
    this.iframe = this.element.querySelector('.iframe-embed__iframe')
    this.cookieNotice = this.element.querySelector('.cookie-notice')

    if (!this.iframe || !this.cookieNotice) {
      return
    }

    this.cookieCategory = this.cookieNotice.getAttribute('data-category') || ''
    this.consentRun = false
    this.consentTimeout = null
    this.consentTimeoutDelay = 250

    if (!this.cookieCategory) {
      return
    }

    window.addEventListener('cf_init', () => this.loadAfterCookieConsent())
    window.addEventListener('cf_update', () => this.loadAfterCookieConsent())
    window.addEventListener('cf_consent', () => {
      window.clearTimeout(this.consentTimeout)
      window.setTimeout(() => this.loadAfterCookieConsent(true), this.consentTimeoutDelay)
    })
  }

  loadAfterCookieConsent(force = false) {
    if (!force && this.consentRun) {
      return
    }

    const consent = window.CookieFirst?.consent || {}

    // eslint-disable-next-line no-undef
    if (environment === 'development' || consent[this.cookieCategory]) {
      this.cookieNotice.setAttribute('hidden', 'hidden')
      this.iframe.src = this.iframe.getAttribute('data-src')
      this.iframe.removeAttribute('data-src')
      this.consentRun = true
    }
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'iframe-embed', IFrameEmbedComponent))
